import { MijnRoute } from '../../mijn-navigatie.model';

export const MORTGAGE_BUILD_FUND_NEW_ADDRESS_BEDANKT: MijnRoute = {
    path: 'bouwdepot/adres-nieuwe-woning-doorgeven/bedankt',
    navigationEvent: 'toBouwdepotAdresNieuweWoningDoorgevenBedankt',
    regex: /^\/hypotheek\/bouwdepot\/adres-nieuwe-woning-doorgeven\/bedankt$/,
    webcomponent: 'mijn-hypotheken-bouwdepot-webcomponent',
    internalPath: 'adres-nieuwe-woning-doorgeven/bedankt'
};
